import { Controller } from "@hotwired/stimulus"

declare const Stripe: any
declare const NProgress: any

export default class extends Controller {
  static targets = [
    "quantitySelect",
    "totalPrice",
    "form",
    "existingCardSection",
    "newCardSection"
  ]
  static values = {
    pricePerReminder: Number
  }

  declare quantitySelectTarget: HTMLSelectElement
  declare totalPriceTarget: HTMLElement
  declare formTarget: HTMLFormElement
  declare existingCardSectionTarget: HTMLElement
  declare newCardSectionTarget: HTMLElement
  declare hasExistingCardSectionTarget: boolean
  declare pricePerReminderValue: number

  updateTotal() {
    const quantity = parseInt(this.quantitySelectTarget.value)
    const totalCents = quantity * this.pricePerReminderValue
    const totalDollars = (totalCents / 100).toFixed(2)

    this.totalPriceTarget.textContent = `$${totalDollars}`
  }

  showNewCardForm() {
    this.existingCardSectionTarget.classList.add('hidden')
    this.newCardSectionTarget.classList.remove('hidden')
  }

  showExistingCardForm() {
    this.newCardSectionTarget.classList.add('hidden')
    this.existingCardSectionTarget.classList.remove('hidden')
  }
}
